import { Component, Input, OnInit } from '@angular/core';
import { Interaction } from 'src/app/pages/interactions/interaction.model';

@Component({
  selector: 'app-interaction-list-item',
  templateUrl: './interaction-list-item.component.html',
  styleUrls: ['./interaction-list-item.component.scss']
})
export class InteractionListItemComponent implements OnInit {

  @Input() interaction: Interaction;

  constructor() { }

  ngOnInit(): void {
  }

}
